import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Image from 'components/global/Image';
import SwiperFooter from 'components/global/SwiperFooter';
import Typography from 'components/global/Typography';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import * as S from './ModuleDetail.styled';

const ModuleTestimonials = () => {
	const { selectedModule } = useSelector((state) => state.otoPackageList);
	const { t } = useTranslation();
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const [swiperRef, setSwiperRef] = useState(null);

	const testimonials = useMemo(() => {
		const testimonials = [];
		for (let stepNumber = 1; stepNumber < 20; stepNumber += 1) {
			const text = `${selectedModule?.slug}.testimonial${stepNumber}`;
			const author = `${selectedModule?.slug}.testimonial${stepNumber}.author`;
			const image = `${selectedModule?.slug}.testimonial${stepNumber}.image`;
			const authorDescription = `${selectedModule?.slug}.testimonial${stepNumber}.authorDescription`;
			if (t(text) !== text && t(author) !== author) {
				testimonials.push({
					text,
					author,
					image: t(image),
					authorDescription
				});
			} else {
				break;
			}
		}
		return testimonials;
	}, [selectedModule]);

	if (testimonials.length === 0) {
		return null;
	}

	return (
		<S.Testimonials>
			<Typography variant="h2" fontWeight="800" noWrap align="center">
				{`${selectedModule?.slug}.testimonials.title`}
			</Typography>
			<S.TestimonialsContent>
				<Swiper
					slidesPerView={isMobile ? 1 : 2}
					grid={{
						rows: 1
					}}
					spaceBetween={24}
					modules={[Autoplay]}
					autoplay={{
						delay: 3000,
						disableOnInteraction: false
					}}
					onSwiper={setSwiperRef}>
					{testimonials?.map((item) => (
						<SwiperSlide key={item.text}>
							<S.TestimonialsItem>
								<Typography variant="p2" noWrap color="var(--content-2)">
									{item.text}
								</Typography>
								<S.TestimonialsAuthor>
									<Image
										url={item.image}
										defaultUrl={item.image}
										alt={t(item.author)}
										width="6rem"
										height="6rem"
									/>
									<div>
										<Typography variant="p2" fontWeight="700">
											{item.author}
										</Typography>
										<Typography variant="p3" color="var(--content-3)">
											{item.authorDescription}
										</Typography>
									</div>
								</S.TestimonialsAuthor>
							</S.TestimonialsItem>
						</SwiperSlide>
					))}
					{testimonials.length > (isMobile ? 1 : 2) && swiperRef && (
						<SwiperFooter cssPosition="relative" swiperRef={swiperRef} />
					)}
				</Swiper>
			</S.TestimonialsContent>
		</S.Testimonials>
	);
};

export default ModuleTestimonials;
